window.o_global.eventQBus.on("assets.dropdown.init", (selector = "") => {
  const dropdownElements = document.querySelectorAll(
    `${selector} .js-p_dropdown__element, ${selector} .js-pl_dropdown__element`
  );

  const changeEventName = "change";
  const changeEventHandler = function () {
    this.setAttribute("data-value", this.value);
  };

  [].forEach.call(dropdownElements, (el) => {
    el.addEventListener(changeEventName, changeEventHandler);
    let event;

    // check if modern browser
    if (typeof Event === "function") {
      event = new Event(changeEventName);
    } else {
      // IE11
      event = document.createEvent("Event");
      event.initEvent(changeEventName, true, true);
    }

    el.dispatchEvent(event);
    window.setTimeout(() => {
      el.nextElementSibling.classList.remove("js-p_label", "js-pl_label");
    }, 100);
  });
});

window.o_global.eventLoader.onAllScriptsExecuted(130, () => {
  window.o_global.eventQBus.emit("assets.dropdown.init", "body");
});
